module.exports = "/_next/static/images/aea457d095ef7558b689d40e2272d630-pay-yourself-md@2x.jpg";